export const SceneKey = {
	Boot: "boot",
	Preload: "preload",
	Game: "game",
} as const;
